<script setup lang="ts">
const items = [
  'Cek ongkir dan bandingkan tarif dari berbagai ekspedisi',
  'Buat resi otomatis dan kirim paket langsung dari HP',
  'Lacak pengiriman real-time, dari pickup hingga sampai ke pembeli',
  'Cairkan dana COD lebih cepat, biar cashflow bisnismu tetap lancar'
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    image-class="order-first lg:order-first"
    title="Kendali Logistik di Genggaman Anda"
    description="Sekarang Anda tidak perlu lagi buka laptop hanya untuk kirim paket atau cek ongkir. Dengan KiriminAja Mobile App, semua aktivitas logistik bisa Anda kelola langsung dari smartphone"
    hero-image="/images/aplikasi-mobile-banner-2.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <Icon
            class="text-primary flex-none"
            name="material-symbols:verified"
            :size="isMobile ? '22px' : '30px'"
          />
          <p class="text-sm lg:text-lg flex-1">
            {{ item }}
          </p>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
